/**
 * @prettier
 */

import React from 'react';
import { Banner, Link } from '@zola/zola-ui';
import styles from './styles.module.less';

const CustomizeWarning = ({ onCustomize, closeModal }) => {
  const onLinkClick = () => {
    if (closeModal) closeModal();
    if (onCustomize) onCustomize();
  };

  return (
    <Banner type="warning">
      <div className={styles.bannerContent}>
        Samples are printed without upgrades. To order a free proof with your selected upgrades
        instead,{' '}
        <Link role="button" onClick={onLinkClick}>
          <span className={styles.bold}>customize your design</span>
        </Link>{' '}
        and use code <span className={styles.bold}>FREEPROOF</span> at checkout.
      </div>
    </Banner>
  );
};

export default CustomizeWarning;



// WEBPACK FOOTER //
// ./src/cards/components/common/SingleSample/CustomizeWarning/CustomizeWarning.jsx